import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { GetReferenceSchemeByIdResolver } from './resolvers/get-reference-scheme-by-id.resolver';
import { ReferenceSchemeOverviewResolver } from './resolvers/reference-scheme-overview.resolver';
import { ReferenceSchemeService } from './services/reference-scheme.service';
import { ReferenceSchemeEffects } from './store/reference-scheme.effects';
import * as referenceSchemeReducer from './store/reference-scheme.reducer';

export function provideReferenceSchemeFeature() {
  return makeEnvironmentProviders([
    provideState('referenceSchemeModule', referenceSchemeReducer.reducer),
    provideEffects(ReferenceSchemeEffects),
    ReferenceSchemeService,
    ReferenceSchemeOverviewResolver,
    GetReferenceSchemeByIdResolver,
  ]);
}
